import React, { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import QRCode from 'qrcode.react';
import { User } from '../../../utils/types';

interface QRCodeModalProps {
  user: User;
  open: boolean;
  onClose: () => void;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({ open, user, onClose }) => {
    const [qrCodeValue, setQrCodeValue] = React.useState<string | null>(null);
    useEffect(() => {
        setQrCodeValue(`${user.uid}`);
    }, [user.uid, user.conferenceCode]);
    return(
    <>
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '50px',
                marginTop: '20px',
            }}>
                {qrCodeValue && <QRCode value={qrCodeValue} size={256} />}
                <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: 'bold', marginTop: '20px' }}>
                    {user.displayName}
                </Typography>
            </DialogContent>
        </Dialog>
    </>
)};

export default QRCodeModal;
